import { AppRoute } from '../../enums';
import { AuthenticationFacade } from '../auth';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  private auth = inject(AuthenticationFacade);
  private navigation = inject(Router);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse && err.status === HttpStatusCode.Unauthorized) {
          this.auth.logout();
          this.navigation.navigate([AppRoute.Login]);
        }
        return throwError(() => err);
      }),
    );
  }
}
